import v from "@/lib/validator";
import { TFunction } from "i18next";

const RegisterClientSchema = (translate: TFunction) => {
  const cnpjValidation = v
    .methods()
    .required({ message: translate("clientsForm.inputs.errorsMessages.required") })
    .min({ length: 14, message: translate("clientsForm.inputs.errorsMessages.cnpj") })
    .max({ length: 14, message: translate("clientsForm.inputs.errorsMessages.cnpj") })
    .regex({ pattern: /^\d{14}$/, message: translate("clientsForm.inputs.errorsMessages.cnpj") });

  const cepValidation = v
    .methods()
    .required({ message: translate("clientsForm.inputs.errorsMessages.required") })
    .min({ length: 8, message: translate("clientsForm.inputs.errorsMessages.cep") })
    .max({ length: 8, message: translate("clientsForm.inputs.errorsMessages.cep") })
    .regex({ pattern: /^\d{8}$/, message: translate("clientsForm.inputs.errorsMessages.cep") });

  const telefoneValidation = v
    .methods()
    .required({ message: translate("clientsForm.inputs.errorsMessages.required") })
    .min({ length: 10, message: translate("clientsForm.inputs.errorsMessages.telefone") })
    .max({ length: 11, message: translate("clientsForm.inputs.errorsMessages.telefone") })
    .regex({ pattern: /^\d{10,11}$/, message: translate("clientsForm.inputs.errorsMessages.telefone") });

  const emailValidation = v
    .methods()
    .required({ message: translate("clientsForm.inputs.errorsMessages.required") })
    .regex({
      pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
      message: translate("clientsForm.inputs.errorsMessages.email"),
    });

  return v.object({
    razaoSocial: v
      .methods()
      .required({ message: translate("clientsForm.inputs.errorsMessages.required") }),
    nomeFantasia: v
      .methods()
      .required({ message: translate("clientsForm.inputs.errorsMessages.required") }),
    cnpj: cnpjValidation,
    cep: cepValidation,
    endereco: v
      .methods()
      .required({ message: translate("clientsForm.inputs.errorsMessages.required") }),
    telefoneResponsavel: telefoneValidation,
    emailResponsavel: emailValidation,
  });
};

export default RegisterClientSchema;
